
export function StartNowAction({ color }: { color: string }) {
  return <div>
    <a style={{ backgroundColor: color }} className="rounded-md text-white p-3 font-semibold decoration-none"
      href='https://www.facebook.com/people/JEAN/100086443823425/' target="_blank" color="white">
      Start now
    </a>
  </div>
}
